import {createAsyncThunk} from '@reduxjs/toolkit';
import {instrumentsApi} from 'api';
import {IInstrumentDetails} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchInstrumentThunk: any = createAsyncThunk<IInstrumentDetails, number>(
  `${prefix} fetchInstrument`,
  async (templateId: number, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await instrumentsApi.getInstrumentById(templateId);
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
